export default {
  init() {
    // JavaScript to be fired on all pages
    const body = $(document.body);

    // Modernizr-style feature detection
    const browserFeatures = {
      csspointerevents: (function() {
        var a = document.createElement('a');
        a.style.cssText = 'pointer-events:auto';
        return a.style.pointerEvents === 'auto';
      })(),
    };
    for(var feature in browserFeatures) {
      body.toggleClass(feature, browserFeatures[feature])
          .toggleClass(`no-${feature}`, !browserFeatures[feature]);
    }

    // Mobile menu toggle
    body.on('click', '.js-mobile-menu-toggle', (e) => {
      e.preventDefault();
      body.toggleClass('has-mobile-menu-open');
    });

    // Collapse mobile menu on navigate
    body.on('click', '.mobile-menu a, .mobile-menu button', () => {
      body.removeClass('has-mobile-menu-open');
    });

    // Click events for navigating to a route on the client app
    body.on('click', '.js-app-navigate', (e) => {
      e.preventDefault();

      const location = $(e.target).closest('.js-app-navigate').attr('data-location');

      if (window.clientApp && window.clientApp.browserHistory) {
        window.clientApp.browserHistory.push(location);
      }
      else {
        window.location.href = location;
      }
    });

    $('.dropdown-toggle').dropdown();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js